module.exports = __webpack_public_path__ + "img/img_brand29.cd502d9b.jpg";